import { getActiveOrFirstUserId, type LeadAssignment } from 'cpool-utils';
import { useTranslation } from 'react-i18next';
import { LuHeadset } from 'react-icons/lu';

import { getAdviserName } from './getAdviserName';
import { useLeadAdvisers } from './useLeadAdvisers';

type Props = { lead: LeadAssignment };

export const CurrentAdviserName: React.FC<Props> = ({ lead }) => {
    const { t } = useTranslation();
    const { data: advisers = [], isLoading } = useLeadAdvisers(lead);
    const currentAdviserId = getActiveOrFirstUserId(lead);
    // no unknown-user flash while the names load
    if (currentAdviserId && isLoading) return null;

    if (!currentAdviserId)
        return (
            <span className="truncate text-sm text-midnight" data-testid="current-adviser-name">
                {t('LEADS.ASSIGNED_USERS.NONE')}
            </span>
        );

    return (
        <span className="flex items-center gap-1 min-w-0 text-sm text-midnight" data-testid="current-adviser-name">
            <LuHeadset aria-label={t('LEADS.ASSIGNED_USERS.OWNER_ICON')} className="size-4 shrink-0" role="img" />
            <span className="truncate">
                {getAdviserName(advisers, currentAdviserId, t('LEADS.ASSIGNED_USERS.UNKNOWN_USER'))}
            </span>
        </span>
    );
};
